/**
 * Coercions (`specs/M2-formula.md` §6). A monday formula is dynamically typed, so every
 * operator and function coerces rather than refusing.
 */
import { isFormulaDate, isFormulaError } from './ast.js';
const DATE_RE = /^\d{4}-\d{2}-\d{2}/;
export function toNumber(value) {
    if (value === null || value === undefined)
        return null;
    if (typeof value === 'number')
        return Number.isFinite(value) ? value : null;
    if (typeof value === 'boolean')
        return value ? 1 : 0;
    if (isFormulaError(value))
        return null;
    if (isFormulaDate(value))
        return Date.parse(`${value.iso}T00:00:00Z`);
    const trimmed = value.trim();
    if (trimmed === '')
        return null;
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : null;
}
export function toDate(value) {
    if (value === null || value === undefined)
        return null;
    if (isFormulaDate(value))
        return value;
    if (isFormulaError(value))
        return null;
    if (typeof value === 'string' && DATE_RE.test(value.trim())) {
        return { kind: 'date', iso: value.trim().slice(0, 10) };
    }
    return null;
}
/** The string an expression renders as when it is the whole result. */
export function toText(value) {
    if (value === null || value === undefined)
        return '';
    if (typeof value === 'string')
        return value;
    if (typeof value === 'boolean')
        return value ? 'true' : 'false';
    if (typeof value === 'number') {
        if (!Number.isFinite(value))
            return '';
        // A whole number never renders a trailing `.0`; anything else keeps what it computed to.
        return Number.isInteger(value) ? String(value) : String(value);
    }
    if (isFormulaDate(value))
        return value.iso;
    return value.message;
}
//# sourceMappingURL=coerce.js.map